import { config } from './sanitize.config';
import type { Sanitizer } from './sanitize.types';

function createSanitizer(): Sanitizer {
    const isBrowser = typeof globalThis.window !== 'undefined' && typeof globalThis.window.document !== 'undefined';

    if (isBrowser) {
        const { browserSanitizer } = require('./sanitize.client');

        return browserSanitizer;
    }

    const { serverSanitizer } = require('./sanitize.server');

    return serverSanitizer;
}

const sanitizer: Sanitizer = createSanitizer();

export function sanitize(html: string): string {
    return sanitizer.sanitize(html, config);
}
